import LinearGradientImpl from 'react-native-web-linear-gradient';

// Compatibility shim:
// `react-native-gifted-charts` does `require('react-native-linear-gradient').LinearGradient`
// (and falls back to `require('expo-linear-gradient').LinearGradient`).
// Export a named `LinearGradient` so `require(...).LinearGradient` works on web without Expo.
export const LinearGradient = LinearGradientImpl as any;

export default LinearGradientImpl as any;
